import { render, staticRenderFns } from "./CidadaosSemAcs.vue?vue&type=template&id=a1da89e2"
import script from "./CidadaosSemAcs.vue?vue&type=script&lang=js"
export * from "./CidadaosSemAcs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports